import { render, staticRenderFns } from "./FollowUpSequenceTab.vue?vue&type=template&id=55da4538&scoped=true&"
import script from "./FollowUpSequenceTab.vue?vue&type=script&lang=js&"
export * from "./FollowUpSequenceTab.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpSequenceTab.vue?vue&type=style&index=0&id=55da4538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55da4538",
  null
  
)

export default component.exports